const de = {
  langName: "Deutsch",
  locale: "de_DE",
  meta: {
    home: ["Stiftung MADE — Rechte, Gesundheit und Solidarität", "MADE ONLUS unterstützt Menschen in schwierigen Lebenslagen mit sozialmedizinischer Hilfe, Wohltätigkeit und Bildung – in der Dominikanischen Republik und in Italien."],
    about: ["Über uns — Stiftung MADE", "Geschichte, Mission und Werte der Fundación MADE: Wir bauen die Grundrechte der Menschen auf, indem wir unsere Kompetenzen zur Verfügung stellen."],
    activities: ["Unsere Aktivitäten — Stiftung MADE", "Sozialmedizinische Hilfe, Wohltätigkeit, Bildung und Ausbildung, Zusammenarbeit mit Fachkräften im Gesundheitswesen und Unterstützung sozialer Einrichtungen."],
    projects: ["Projekte — Stiftung MADE", "Die dokumentierten Projekte von MADE: La Romana in der Dominikanischen Republik und Villa Bevilacqua Relais in Rapagnano in den Marken."],
    laRomana: ["Projekt La Romana, Dominikanische Republik — MADE", "Das sozialmedizinische Projekt von MADE in La Romana: ein Krankenhaus für Bedürftige und bis dahin eine mobile Klinik mit Fachärzten."],
    villa: ["Villa Bevilacqua Relais, Rapagnano (FM) — MADE", "Das Projekt Villa Bevilacqua Relais in den Marken: Grundrisse, 3D-Visualisierungen und dokumentierte Merkmale der Einrichtung."],
    team: ["Das Team — Stiftung MADE", "Die Präsidentin, der medizinische Direktor und das medizinische Personal der Fundación MADE."],
    gallery: ["Fotogalerie — Stiftung MADE", "Originalfotos der Menschen, der medizinischen Arbeit, der Mitarbeitenden und der Projekte von MADE."],
    donate: ["Jetzt spenden — MADE ONLUS unterstützen", "Unterstützen Sie MADE per Banküberweisung, mit einer Dauerspende per SDD-Mandat oder mit Ihrer 5×1000-Zuweisung."],
    contact: ["Kontakt — Stiftung MADE", "Schreiben Sie MADE ONLUS: Adresse, Fax, E-Mail und Kontaktformular."],
    privacy: ["Datenschutzerklärung — MADE", "Informationen zur Verarbeitung personenbezogener Daten, die über die Website von MADE ONLUS erhoben werden."],
    cookies: ["Cookie-Richtlinie — MADE", "Informationen zu Cookies und ähnlichen Technologien auf der Website von MADE ONLUS."],
    notFound: ["Seite nicht gefunden — MADE", "Die angeforderte Seite existiert nicht."],
  },
  nav: { home: "Startseite", about: "Über uns", activities: "Aktivitäten", projects: "Projekte", team: "Team", gallery: "Galerie", donate: "Spenden", contact: "Kontakt", donateNow: "Jetzt spenden", menu: "Menü öffnen", close: "Menü schließen", skip: "Zum Inhalt springen", language: "Sprache" },
  common: {
    discover: "Mehr erfahren",
    support: "MADE unterstützen",
    backToProjects: "Alle Projekte",
    copy: "Kopieren",
    copied: "In die Zwischenablage kopiert",
    viewAll: "Alle ansehen",
    requestInfo: "Informationen anfordern",
    source: "Quelle: Dokumentation von MADE",
    statusNote: "Die Unterlagen der Stiftung stellen das Projekt und seine Ziele vor; Angaben zu Fertigstellung oder Inbetriebnahme enthalten sie nicht.",
    projectGallery: "Projektgalerie",
    supportProject: "Dieses Projekt unterstützen",
    supportProjectText: "Sie können das Projekt, das Sie unterstützen möchten, im Verwendungszweck der Überweisung angeben.",
  },
  home: {
    eyebrow: "Fundación MADE · MADE ONLUS",
    titleLines: ["Gemeinsam bauen", "wir eine bessere", "Zukunft."],
    subtitle: "Jede solidarische Geste kann dazu beitragen, die Grundrechte der Menschen zu schützen und jene zu unterstützen, die es am dringendsten brauchen.",
    ctaMission: "Unsere Mission entdecken",
    ctaSupport: "MADE unterstützen",
    scroll: "Scrollen",
    marquee: ["Sozialmedizinische Hilfe", "Wohltätigkeit", "Bildung", "Ausbildung", "Grundrechte", "La Romana", "Rapagnano"],
    aboutEyebrow: "Über uns",
    aboutTitle: "Wir bauen die Grundrechte der Menschen auf.",
    aboutText: "Wir unterstützen, wir teilen, wir stellen unsere Kompetenzen jenen Notlagen zur Verfügung, denen wir begegnen und die uns begegnen.",
    activitiesEyebrow: "Unsere Aktivitäten",
    activitiesTitle: "Fürsorge, Unterstützung und Wissen für Menschen, die in Armut leben.",
    projectsEyebrow: "Ausgewählte Projekte",
    projectsTitle: "Zwei Regionen, ein gemeinsames Engagement.",
    quote: "„Deine Zukunft hängt davon ab, was du heute tust – nicht morgen.“",
    teamEyebrow: "Das Team",
    teamTitle: "Menschen, die ihr Können in den Dienst anderer stellen.",
    galleryEyebrow: "Galerie",
    galleryTitle: "Gesichter, Gesten, Orte.",
    donateEyebrow: "Spenden",
    donateTitle: "Ihre Unterstützung macht unsere Arbeit möglich.",
    contactEyebrow: "Kontakt",
    contactTitle: "Möchten Sie uns kennenlernen, mit uns zusammenarbeiten oder Informationen erhalten?",
    contactText: "Schreiben Sie uns – wir antworten Ihnen so bald wie möglich.",
  },
  about: {
    eyebrow: "Über uns",
    titleLines: ["Wer ist", "MADE"],
    intro: "Wir unterstützen, wir teilen, wir stellen unsere Kompetenzen jenen Notlagen zur Verfügung, denen wir begegnen und die uns begegnen.",
    motto: "Wir bauen die Grundrechte der Menschen auf.",
    storyTitle: "Unsere Geschichte",
    story: "Präsidentin der Fundación MADE ist die Rechtsanwältin Marzia Bevilacqua. Seit jeher für soziale Fragen sensibilisiert und getragen vom Wunsch, die Rechte der Schwächsten zu schützen, gründete sie die Fundación MADE nach einer Begegnung mit einer Gruppe kubanischer Ärzte in Santo Domingo.",
    missionTitle: "Mission",
    mission: "Bedürftigen sozialmedizinische Versorgung zu garantieren und Menschen, die in Armut und Ausgrenzung leben, durch Wohltätigkeit, Unterricht und Ausbildung zu unterstützen.",
    visionTitle: "Vision",
    vision: "Eine Zukunft, in der die Grundrechte jedes Menschen geschützt sind – beginnend mit dem, was wir heute zu tun beschließen.",
    valuesTitle: "Unsere Werte",
    values: [
      ["Unterstützung", "Wir stehen den Notlagen zur Seite, denen wir begegnen und die uns begegnen."],
      ["Teilen", "Wir teilen Mittel, Zeit und Erfahrungen mit denen, die sie am meisten brauchen."],
      ["Kompetenz", "Wir stellen fachliches Können zur Verfügung, allen voran medizinisches."],
      ["Würde", "Wir schützen die Grundrechte jedes Menschen."],
    ],
    italyTitle: "MADE ONLUS in Italien",
    italyText: "In Italien ist die Stiftung als MADE ONLUS mit Sitz in Corso Cavour 86 in Macerata tätig und sammelt Spenden zur Unterstützung ihrer Aktivitäten.",
  },
  activities: {
    eyebrow: "Aktivitäten",
    titleLines: ["Unsere", "Aktivitäten"],
    intro: "Die Fundación MADE stützt ihre Arbeit auf sozialmedizinische Hilfe, Wohltätigkeit, Unterricht und Ausbildung für Menschen, die in Armut und Ausgrenzung leben, und trägt mit Spenden zum Bau von Einrichtungen bei, die dem Stiftungszweck dienen.",
    items: [
      ["Sozialmedizinische Hilfe", "Vorrangiges Ziel der Stiftung ist es, Bedürftigen sozialmedizinische Versorgung zu garantieren – auch mit einer mobilen Klinik, die selbst die unzugänglichsten Gebiete der Dominikanischen Republik erreichen kann."],
      ["Wohltätigkeit und Hilfe für schutzbedürftige Menschen", "Wir unterstützen Menschen, die in Armut und Ausgrenzung leben, und stellen ihnen Mittel und Kompetenzen zur Verfügung."],
      ["Bildung und Ausbildung", "Unterricht und Ausbildung sind die Werkzeuge, mit denen wir den Menschen, denen wir begegnen, neue Möglichkeiten eröffnen."],
      ["Zusammenarbeit mit Fachkräften im Gesundheitswesen", "Das von MADE bereitgestellte ärztliche und pflegerische Personal besteht aus einem Team von Fachärzten kubanischer Herkunft."],
      ["Soziale Einrichtungen und Initiativen", "Mit Spenden tragen wir zum Bau von Einrichtungen bei, die dem Stiftungszweck dienen."],
    ],
    structures: ["Krankenhäuser", "Brunnen", "Sozialzentren", "Schulen"],
    structuresNote: "In den Unterlagen der Stiftung genannte Beispiele für Einrichtungen.",
  },
  projects: {
    eyebrow: "Projekte",
    titleLines: ["Das", "Projekt"],
    intro: "Die in den Unterlagen der Stiftung vorgestellten Projekte: ein sozialmedizinisches Vorhaben in der Dominikanischen Republik und eine Einrichtung in den Marken, Italien.",
    objectivesTitle: "Dokumentierte Ziele",
    laRomana: {
      name: "La Romana",
      place: "La Romana · Dominikanische Republik",
      short: "Der Bau eines Krankenhauses für die sozialmedizinische Versorgung Bedürftiger und bis dahin eine mobile Klinik.",
      intro: "Das Werk, das die Fundación MADE verwirklichen möchte – mit dem vorrangigen Ziel, Bedürftigen sozialmedizinische Versorgung zu garantieren –, ist der Bau eines Krankenhauses.",
      objectives: [
        "Bau eines Krankenhauses für die sozialmedizinische Versorgung Bedürftiger.",
        "Einsatz einer mobilen Klinik bis zur Fertigstellung des Krankenhauses, die auch die unzugänglichsten Gebiete der Dominikanischen Republik erreichen kann.",
        "Bereitstellung von spezialisiertem ärztlichem und pflegerischem Personal.",
      ],
      specialistsTitle: "Die Fachrichtungen des medizinischen Teams",
      specialistsText: "Derzeit besteht das von der Fundación MADE bereitgestellte ärztliche und pflegerische Personal aus einem Team von Fachärzten, alle kubanischer Herkunft, für:",
      specialists: ["Orthopädie", "Urologie", "Gynäkologie", "Allgemeinmedizin", "Innere Medizin", "Anästhesiologie"],
    },
    villa: {
      name: "Villa Bevilacqua Relais",
      place: "Rapagnano (FM) · Marken · Italien",
      short: "Das Projekt einer Einrichtung auf vier Ebenen mit Räumen für Körperpflege, Arztpraxen, Zimmern, Dachgärten und einem Bauernhof-Kindergarten mit Tieren.",
      intro: "Das Projekt Villa Bevilacqua Relais in Rapagnano in der Provinz Fermo wird in den Unterlagen mit einer Luftaufnahme des Geländes, den Grundrissen aller Etagen und 3D-Visualisierungen der Einrichtung dargestellt.",
      objectives: [
        "Eine Einrichtung mit einem Bauernhof-Kindergarten (Agrinido) mit Tieren, einem Bereich für die Tiere und einem Kinderspielplatz.",
        "Im Erdgeschoss: Speisesaal, Fitnessraum, Physiotherapie, Körperpflege und Arztpraxen.",
        "Modul mit 20/22 Plätzen im bestehenden Gebäude, mit Zimmern im ersten und zweiten Obergeschoss.",
      ],
      floorsTitle: "Die Grundrisse",
      floors: [
        ["Souterrain", "Küche (Höhe 3,40 m), Personalräume, Wäscherei und Heizraum. Modul mit 20/22 Plätzen im bestehenden Gebäude (Zimmer im ersten und zweiten Obergeschoss mit geringeren Akkreditierungsanforderungen).", "planSB"],
        ["Erdgeschoss", "Speisesaal 150 m², Fitnessraum 150 m², Aufenthaltsraum 85 m², Physiotherapie 50 m², Sanitärbereich 40 m², Körperpflege 65 m², Besprechungsraum 150 m², Büros 50 m², Empfang 60 m², Arztpraxen und Nebenräume 185 m².", "planGF"],
        ["Erstes Obergeschoss", "Acht Zimmer mit Bad, Personalraum und Dachgarten. Verfügbare Fläche: 16 Plätze in 8 Zimmern.", "planFF"],
        ["Zweites Obergeschoss (Dachgeschoss)", "Zimmer, Personalraum, Ausgang zur Fluchttreppe und Dachgarten. Verfügbare Fläche: 6 Plätze in 2 Zimmern oder 4 Plätze in 1 Zimmer mit Personalraum.", "planSF"],
      ],
      renderTitle: "3D-Visualisierungen",
      renderText: "Die Einrichtung sieht einen Bauernhof-Kindergarten mit Tieren vor, mit einem Bereich für die Tiere und einem Spielplatz für Kinder.",
      aerialTitle: "Das Gelände",
      aerialText: "Luftaufnahme des Grundstücks der Villa Bevilacqua Relais in Rapagnano (FM).",
      elevationsTitle: "Ansichten",
    },
  },
  team: {
    eyebrow: "Team",
    titleLines: ["Das", "Team"],
    intro: "Die in der Broschüre der Stiftung vorgestellten Personen und das von MADE bereitgestellte medizinische Personal.",
    presidentRole: "Die Präsidentin",
    presidentName: "RAin Marzia Bevilacqua",
    presidentBio: "Seit jeher für soziale Fragen sensibilisiert und getragen vom Wunsch, die Rechte der Schwächsten zu schützen, gründete sie die Fundación MADE nach einer Begegnung mit einer Gruppe kubanischer Ärzte in Santo Domingo.",
    directorRole: "Der medizinische Direktor",
    directorName: "Dr. Dennis Livan Gonzalez Martinez",
    directorBio: [
      "Er studierte Medizin und Chirurgie am Höheren Institut für Medizinische Wissenschaften in Havanna, Kuba, und spezialisierte sich auf Orthopädie und Traumatologie.",
      "Mehrere Jahre lang arbeitete er an den renommiertesten Kinderkliniken Havannas.",
      "2007 wurde er im Rahmen einer humanitären Mission der kubanischen Regierung nach Haiti entsandt, wo er die Opfer des verheerenden Erdbebens von 2010 betreute.",
      "2012 zog er in die Dominikanische Republik. 2015 kam er nach Italien.",
      "Auf seiner Erfahrung, seinem Können und seiner Menschlichkeit baut die Fundación MADE ihre Arbeit auf und vertraut ihm deren operative Leitung an.",
    ],
    staffTitle: "Medizinisches Personal und Mitarbeitende",
    staffText: "Das ärztliche und pflegerische Personal von MADE besteht aus einem Team von Fachärzten kubanischer Herkunft. Die Fotos stammen aus der Dokumentation der Stiftung.",
  },
  gallery: {
    eyebrow: "Galerie",
    titleLines: ["Fotogalerie"],
    intro: "Originalfotos aus der Dokumentation der Stiftung.",
    all: "Alle",
    cats: { people: "Menschen und Gemeinschaften", health: "Medizinische Arbeit", volunteers: "Ehrenamtliche und Mitarbeitende", projects: "Projekte und Einrichtungen", architecture: "Architektonische Dokumentation" },
    close: "Schließen",
    prev: "Vorheriges Bild",
    next: "Nächstes Bild",
    open: "Bild vergrößern",
    captions: {
      handsWater: "Hände und Wasser – Titelbild der MADE-Broschüre",
      smilingGirls: "Zwei lächelnde Mädchen",
      girlBlue: "Ein Mädchen im blauen T-Shirt",
      baby: "Ein Kind auf dem Arm",
      twoChildren: "Zwei Kinder",
      childCap: "Ein Kind mit gelber Mütze im Krankenhaus",
      childBed: "Ein junger Patient",
      drDennis: "Dr. Dennis Livan Gonzalez Martinez, medizinischer Direktor",
      doctors: "Ärzte im Kittel",
      staff: "Medizinisches Personal",
      teamShirts: "Die MADE-Gruppe in den T-Shirts der Stiftung",
      volunteerChild: "Ein Mitarbeiter mit einem Kind",
      volunteerElderly: "Eine MADE-Mitarbeiterin mit einem älteren Mann",
      selfie: "Eine Mitarbeiterin mit Kindern",
      kidsBanner: "Kinder vor dem MADE-Logo",
      drafting: "Das Projekt – La Romana, Dominikanische Republik",
      aerial: "Villa Bevilacqua Relais – Luftaufnahme, Rapagnano (FM)",
      render3d: "Villa Bevilacqua Relais – 3D-Visualisierung",
      agrinido: "3D-Visualisierung: Bauernhof-Kindergarten mit Tieren und Spielplatz",
      planSB: "Grundriss – Souterrain",
      planGF: "Grundriss – Erdgeschoss",
      planFF: "Grundriss – erstes Obergeschoss",
      planSF: "Grundriss – zweites Obergeschoss (Dachgeschoss)",
      elevations: "Ansichten der Einrichtung",
    },
  },
  donate: {
    eyebrow: "Spenden",
    titleLines: ["Jetzt spenden", "für MADE Italien"],
    intro: "Helfen Sie uns, die ONLUS MADE bei ihrer Arbeit zu unterstützen.",
    bankTitle: "Überweisung auf das Bankkonto",
    ibanLabel: "IBAN",
    bankLabel: "Bank",
    holderLabel: "Kontoinhaber",
    causalLabel: "Verwendungszweck",
    causal: "Wenn Ihre Spende einem bestimmten Projekt zugutekommen soll, können Sie es im Verwendungszweck angeben.",
    sddTitle: "Dauerspende",
    sddText: "Dauerspenden über das SDD-Mandat (ehemals RID) erfolgen als regelmäßige Überweisung per Lastschrift. Sie sind für uns sehr wichtig: Sie ermöglichen es uns, unsere Aktivitäten besser zu planen und unsere Initiativen und Einsätze mittel- bis langfristig vorzubereiten.",
    sddThanks: "Danke, dass Sie diese Form der Unterstützung in Ihrem Umfeld bekannt machen.",
    sddHow: "Fordern Sie das SDD-Formular an, füllen Sie es aus und senden Sie es per Fax oder E-Mail zurück.",
    fiveTitle: "5×1000",
    fiveText: "Für Steuerpflichtige in Italien: Wenn Sie Ihre 5×1000-Zuweisung noch nicht vergeben haben, hier ist unsere Steuernummer:",
    cfLabel: "Steuernummer (Codice fiscale)",
    ctaInfo: "Informationen anfordern",
    ctaSdd: "SDD-Formular anfordern",
    noOnline: "Diese Website nimmt keine Online-Zahlungen entgegen: Spenden erfolgen ausschließlich per Banküberweisung, SDD-Mandat oder 5×1000.",
    copyIban: "IBAN kopieren",
    copyCf: "Steuernummer kopieren",
  },
  contact: {
    eyebrow: "Kontakt",
    titleLines: ["Schreiben", "Sie uns"],
    intro: "Für Informationen, eine Zusammenarbeit oder um das Formular für Dauerspenden anzufordern.",
    detailsTitle: "Kontaktdaten",
    addressLabel: "Adresse",
    faxLabel: "Fax",
    emailLabel: "E-Mail",
    form: {
      title: "Kontaktformular",
      name: "Vor- und Nachname",
      email: "E-Mail",
      subject: "Betreff",
      message: "Nachricht",
      consent: "Ich habe die Datenschutzerklärung gelesen und willige in die Verarbeitung meiner Daten zur Beantwortung meiner Anfrage ein.",
      privacyLink: "Datenschutzerklärung lesen",
      submit: "Nachricht senden",
      sending: "Wird gesendet…",
      success: "Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet. Wir antworten Ihnen so bald wie möglich.",
      error: "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder schreiben Sie uns per E-Mail.",
      required: "Pflichtfeld",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      consentRequired: "Bitte akzeptieren Sie die Datenschutzerklärung",
      minMessage: "Die Nachricht muss mindestens 10 Zeichen enthalten",
      requiredNote: "Alle Felder sind Pflichtfelder.",
    },
  },
  footer: {
    tagline: "Wir bauen die Grundrechte der Menschen auf.",
    navTitle: "Navigation",
    contactTitle: "Kontakt",
    donateTitle: "Unterstützen Sie uns",
    rights: "Alle Rechte vorbehalten.",
    privacy: "Datenschutz",
    cookies: "Cookies",
    cookieSettings: "Cookie-Einstellungen",
    photos: "Fotos und Bilder: Originaldokumentation von MADE.",
  },
  cookie: {
    text: "Wir verwenden nur die technische Speicherung, die für den Betrieb der Website erforderlich ist. Mit Ihrer Einwilligung kann die Hosting-Plattform Nutzungsstatistiken erheben.",
    accept: "Akzeptieren",
    reject: "Nur notwendige",
    more: "Cookie-Richtlinie",
  },
  legal: {
    privacyTitle: "Datenschutzerklärung",
    privacy: [
      ["Verantwortlicher", "MADE ONLUS, Corso Cavour 86 – 62100 Macerata (Italien). Steuernummer 93078840431. E-Mail: madeonlus-italia@gmail.com."],
      ["Erhobene Daten", "Über das Kontaktformular erheben wir Name, E-Mail-Adresse, Betreff und Text der Nachricht sowie die Sprache der Website und das Sendedatum."],
      ["Zweck und Rechtsgrundlage", "Die Daten werden ausschließlich zur Beantwortung Ihrer Anfrage auf Grundlage Ihrer Einwilligung verarbeitet (Art. 6 Abs. 1 lit. a DSGVO)."],
      ["Speicherdauer", "Die Daten werden so lange gespeichert, wie es zur Bearbeitung der Anfrage erforderlich ist, und nicht zu kommerziellen Zwecken an Dritte weitergegeben."],
      ["Ihre Rechte", "Sie können jederzeit Auskunft, Berichtigung, Löschung oder Einschränkung der Verarbeitung Ihrer Daten verlangen, Ihre Einwilligung widerrufen und Beschwerde bei einer Aufsichtsbehörde einlegen – per E-Mail an den Verantwortlichen."],
    ],
    cookiesTitle: "Cookie-Richtlinie",
    cookies: [
      ["Technische Speicherung", "Die Website speichert Ihre Cookie-Auswahl in Ihrem Browser. Diese Information ist für den Betrieb der Website erforderlich und bedarf keiner Einwilligung."],
      ["Statistiken der Plattform", "Die Hosting-Plattform kann Werkzeuge zur Nutzungsmessung einsetzen. Diese werden nur aktiviert, wenn Sie im Banner zustimmen; mit „Nur notwendige“ wird die Erhebung deaktiviert."],
      ["Einstellungen verwalten", "Sie können Ihre Auswahl jederzeit über den Link „Cookie-Einstellungen“ in der Fußzeile ändern."],
    ],
  },
  notFound: { title: "Seite nicht gefunden", text: "Die gesuchte Seite existiert nicht oder wurde verschoben.", back: "Zur Startseite" },
};

export default de;
